/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.badge {
  width: calc(var(--spacing, 0.25rem) * 2.5);
  height: calc(var(--spacing, 0.25rem) * 2.5);
  border-radius: calc(infinity * 1px);
}
.SUCCESS {
  background-color: var(--color-success-dark, #15803d);
}
.WARNING {
  background-color: var(--color-warning-dark, #c2410c);
}
.DANGER {
  background-color: var(--color-danger-dark, #b91c1c);
}
.NEUTRAL {
  background-color: var(--color-emphasis-high, #000);
}
.LIGHT {
  color: var(--color-emphasis-high, #000);
  background-color: var(--color-gray-200, #e5e5e5);
}
.DARK {
  background-color: var(--color-neutral-700, oklch(37.1% 0 none));
}
.BLUE {
  background-color: var(--color-blue-700, oklch(48.8% 0.243 264.376));
}
